import { FC, useEffect, useRef, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import JoinUsWin from './Win';
import { useLang } from '@/i18n';
import { useMembersDispatch, useMembersStore } from '@/components/MembersDay/MembersProvider';
import getLocal from '@/app/utils/getLocal';
import { i18nText } from '@/app/eflayout/Footer/i18nText';
import gtm from '@/utils/gtm';
import { getPrivacyPolicy } from '@/utils/common';

import { IPageStatus } from '@/components/MembersDay/type';
import { signupCookie } from '@/utils/cookies/signupCookie';

interface IProps {
    type?: string;
}

const Banner: FC<IProps> = ({}) => {
    const { locale, pathname } = getLocal();
    const { t: tt } = useLang('membersday.teaser.JoinUs');
    const { t: ta } = useLang('membersday.activity.JoinUs');
    const [showType, setShowType] = useState('');
    const isDefaultSelect = locale === 'us' ? true : false;
    const [isActive, setIsActive] = useState(isDefaultSelect);
    const { isLogin, pageStatus, joinUsWinStatus } = useMembersStore();
    const dispatch = useMembersDispatch();
    const [isEnterA, setisEnterA] = useState(false);
    const isEnterRefA = useRef(false);
    const textTips = i18nText[locale] || i18nText['en'];
    const [showProTips, setShowProTips] = useState(false);

    const t = (() => {
        if (locale === 'jp' && pageStatus === IPageStatus.ACTIVITY) {
            return ta;
        }
        return tt;
    })();

    // 因为加了个需求从banner打开该弹窗
    useEffect(() => {
        if (!joinUsWinStatus) return;

        gtm.push({
            event: 'uaEvent',
            event_name: 'ecocredits_button',
            type: 'Join',
            list_name: t('title'),
            button_name: t('btnText2'),
        });
        if (!isLogin) {
            signupCookie?.({
                sector_name: t('title'),
                entry_position: 2,
            });
            location.href = `/${locale}/login?redirect=${encodeURIComponent(`/${locale}${pathname}#teaser-JoinUs`)}`;
            return;
        }
        setShowType('JoinUsWin');
    }, [joinUsWinStatus]);

    useEffect(() => {
        const elem = document.querySelector(`#teaser-JoinUs`);
        if (elem) {
            window.addEventListener('scroll', () => {
                const clientH = document.documentElement.clientHeight;
                const enterAH = clientH - 150;
                const { top } = elem.getBoundingClientRect();
                const hIsEnterA = top < enterAH; //距离已进入
                if (!isEnterRefA.current && hIsEnterA) {
                    isEnterRefA.current = true;
                    setisEnterA(true);
                } else if (isEnterRefA.current && !hIsEnterA) {
                    isEnterRefA.current = false;
                    setisEnterA(false);
                }
            });
        }
    }, []);

    // 正式弹窗
    const openHandleB = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'ecocredits_button',
            type: 'Join',
            list_name: t('title'),
            button_name: t('btnText2'),
        });
        if (!isLogin) {
            signupCookie?.({
                sector_name: t('title'),
                entry_position: 5,
            });
            location.href = `/${locale}/login?redirect=${encodeURIComponent(`/${locale}${pathname}#teaser-JoinUs`)}`;
            return;
        }
        if (!isActive) {
            setShowProTips(true);
            return;
        }
        setShowType('JoinUsWin');
        document.body.classList.add('ef-has-modal-full-viewport');
        setShowProTips(false);
    };
    // 弹窗关闭回调
    const closeCallback = (type?: string) => {
        setShowType('');
        // 同步更改context的数据
        dispatch({
            type: 'changeJoinUsWinStatus',
            payload: false,
        });
        document.body.classList.remove('ef-has-modal-full-viewport');
    };
    // 点击切换选择
    const toggleHandle = () => {
        const isActive2 = !isActive;
        setIsActive(isActive2);
    };

    return (
        <>
            <div className={`${styled.Banner}`} id="teaser-JoinUs">
                <div className={`members-day-inter editor-ani-trigger${isEnterA ? ' isEnter' : ''}`}>
                    <div className="members-day-title editor-ani-title-1">{t('title')}</div>
                    <div className="members-day-sub-title editor-ani-title-2">
                        {t.rich('subTitle1', {
                            color2: (text: string) => <span className="text-color2">{text}</span>,
                        })}
                    </div>
                    <div className="img-box-a">
                        <EditorImg
                            pc="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006165337/Reviewjpg.jpg"
                            h5="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006086333/Reviewjpg.jpg"
                        />
                        <div className="img-box-a-box">
                            <div className="members-day-text-inter">
                                <div className="members-day-text-inter-a1">
                                    <div className="img-box-a-line">{t('desc1')}</div>
                                    <div className="img-box-a-msg-box">
                                        <button className="img-box-a-btn temp-only-teaser" onClick={openHandleB}>
                                            {t('btnText1')}
                                        </button>
                                        <button className="img-box-a-btn temp-only-activity" onClick={openHandleB}>
                                            {t('btnText2')}
                                        </button>
                                        {showProTips && <p className="joinInProtocol-tips">{textTips.site_bottom_subscription_email_protocol_hint}</p>}
                                        <div className={`join-in-protocol${isActive ? ' join-in-protocol-select' : ''}`} onClick={toggleHandle}>
                                            <span className="join-in-protocol-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <rect x="0.5" y="0.5" width="13" height="13" stroke="#FFBD3C" />
                                                    <path d="M3 6.5L5.5 9L10.5 4" stroke="#FFBD3C" strokeWidth="1.2" strokeLinecap="square" />
                                                </svg>
                                            </span>
                                            {t.rich('joinInProtocol', {
                                                link: (text: string) => {
                                                    const link =
                                                        locale !== 'jp'
                                                            ? getPrivacyPolicy(locale)
                                                            : 'https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html';
                                                    return (
                                                        <a className="link" href={link} target="_blank" rel="noreferrer">
                                                            {text}
                                                        </a>
                                                    );
                                                },
                                                link2: (text: string) => (
                                                    <a
                                                        className="link"
                                                        href={`https://${locale}.ecoflow.com/policies/terms-of-service`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {text}
                                                    </a>
                                                ),
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showType === 'JoinUsWin' && <JoinUsWin callback={closeCallback} />}
        </>
    );
};

export default Banner;
